import { DEFAULT_CURRENCY, parseCustomerCurrency } from '@/config/currency';

export type PriceValueStatus = 'free' | 'inquiry' | 'N/A';

export type TPriceValue = {
  amount: number | null;
  status: PriceValueStatus | null;
};

/**
 * Formats a numeric money amount using the API-provided currency.
 * Does not convert currencies — display only.
 */
export const formatMoney = (
  amount: number | null | undefined,
  currency: string | null | undefined
): string => {
  if (amount == null || Number.isNaN(Number(amount))) {
    return '';
  }

  const currencyCode = currency ? parseCustomerCurrency(currency) : DEFAULT_CURRENCY;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(Number(amount));
};

const PRICE_STATUS_LABELS: Record<PriceValueStatus, string> = {
  free: 'Free',
  inquiry: 'Inquiry',
  'N/A': 'N/A',
};

/** Formats a PriceValueDto cell for rate tables. */
export const formatPriceValue = (
  value: TPriceValue | null | undefined,
  currency: string | null | undefined
): string => {
  if (!value) {
    return '—';
  }

  if (value.status) {
    return PRICE_STATUS_LABELS[value.status] ?? value.status;
  }

  if (value.amount == null) {
    return '—';
  }

  return formatMoney(value.amount, currency);
};
